import { render, staticRenderFns } from "./AddWorkers.vue?vue&type=template&id=84066efc&scoped=true"
import script from "./AddWorkers.vue?vue&type=script&lang=js"
export * from "./AddWorkers.vue?vue&type=script&lang=js"
import style0 from "./AddWorkers.vue?vue&type=style&index=0&id=84066efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84066efc",
  null
  
)

export default component.exports